// extracted by mini-css-extract-plugin
module.exports = {"modalContent":"UpgradeEpcsModal_modalContent__-M-Gt","modalForm":"UpgradeEpcsModal_modalForm__3NbXh","modalFooter":"UpgradeEpcsModal_modalFooter__2NcoY"};